/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListIdtypeXResponse as AgentApiContractListIdtypeXResponse } from '../../models/AgentApi/Contract/list-idtype-x-response';

export interface ApiAgentListIdtypeXGet$Params {

/**
 * agent change id
 */
  shiftId?: number;

/**
 * interface language/null
 */
  lang?: string;
}

export function apiAgentListIdtypeXGet(http: HttpClient, rootUrl: string, params?: ApiAgentListIdtypeXGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListIdtypeXResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListIdtypeXGet.PATH, 'get');
  if (params) {
    rb.query('shiftId', params.shiftId, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractListIdtypeXResponse>>;
    })
  );
}

apiAgentListIdtypeXGet.PATH = '/api/Agent/ListIdtypeX';
